import type { MembersResponse } from '@server/types/responseTypes'
import { apiGet, createOrgApiUrl } from '@/utils/apiUtils'

export const fetchMembers = async (orgId: string | null) => {
  if (!orgId) return []
  const res = await apiGet<MembersResponse>(createOrgApiUrl(orgId, 'members'))
  return res.data
}
